<template>
    <v-container style="margin: 60px 10%" v-if="producto">
      <Pwa :activador="activador"/>
      <vueHeadful
      :title="producto.titulo + ' - TrArtist'"
      :description="producto.descripcion"
      :image="producto.imagenPrincipal"
      :url="'https://trartist.com' + $route.fullPath"
      :keywords="producto.etiquetas"
      />
        <v-row>
            <v-col cols="12" xs="12" md="8">
              <v-row>
                <v-col cols="3">
                  <v-row>
                      <v-col cols="12" style="padding: 0 25% 25px">
                          <v-img :src="producto.imagenPrincipal" @click="selImagen(producto.imagenPrincipal, 'imagen')"/>
                      </v-col>
                      <template v-if="producto.imagenes[0]">
                        <v-col cols="12" v-for="(i, index) in producto.imagenes.slice(0, 2)" :key="index" style="padding: 25px 25%">
                            <v-img :src="i" @click="selImagen(i, 'imagen')" />
                        </v-col>
                      </template>
                      <v-col cols="12" v-if="producto.video" style="padding: 25px 25%">
                        <div class="video-wrapper" @click="selImagen(i, 'video')">
                        <iframe style="pointer-events: none;" width="500" height="300" :src="`https://www.youtube.com/embed/${producto.video}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9">
                    <zoom v-if="tipoPreview === 'imagen'" :img-normal="imagenSeleccionada" :scale="2" />
                    <div class="video-wrapper" v-else>
                    <iframe width="560" height="315" :src="`https://www.youtube.com/embed/${producto.video}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <v-row v-if="$vuetify.breakpoint.name !== 'xs'">
                      <v-col cols="12">
                        <span class="grey--text">{{$t('Formularios.VerificarColor')}}</span>
                      </v-col>
                      <v-col v-if="producto.aceptarCreatC" cols="12" class="pb-0 pt-0">
                        <span class="grey--text">{{$t('Formularios.AcogidoCreativeC')}}</span>
                        <a style="color: rgb(47, 136, 136) !important;" href="/creativecommons" target="_blank">
                          {{$t('Formularios.Aqui')}}</a>
                      </v-col>
                      <v-col cols="12" class="pb-5 pt-5" style="line-height:35px" >
                        <div v-if="getIdioma === 'es'" >
                        <h2>{{$t('Formularios.Descripcion')}}</h2>
                        <p style="text-align:justify">{{producto.descripcion}}</p>
                        </div>
                         <div v-else >
                          <h2>{{$t('Formularios.Descripcion')}}</h2>
                        <p style="text-align:justify">{{producto.descripcionEn}}</p>
                        </div>
                      </v-col>
                      <v-col cols="12" class="py-0">
                          <div  v-if="getIdioma === 'es'">
                        <h2>{{$t('Formularios.Materiales')}}</h2>
                        <p style="text-align:justify">{{producto.materiales}}</p>
                          </div>
                           <div v-else >
                        <h2>{{$t('Formularios.Materiales')}}</h2>
                        <p style="text-align:justify">{{producto.materialesEn}}</p>
                          </div>
                        <br>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <div v-if="getIdioma === 'es'" >
                        <h2>{{$t('Formularios.Tecnica')}}</h2>
                        <p style="text-align:justify">{{producto.tecnica}}</p>
                        </div>
                         <div v-else >
                        <h2>{{$t('Formularios.Tecnica')}}</h2>
                        <p style="text-align:justify">{{producto.tecnicaEn}}</p>
                        </div>
                        <br>
                      </v-col>
                      <v-col cols="12" class="py-0" v-if="producto.cuidados">
                        <div v-if="getIdioma === 'es'" >
                        <h2>{{$t('Formularios.Cuidados')}}</h2>
                        <p style="text-align:justify">{{producto.cuidados}}</p>
                        </div>
                         <div v-else >
                        <h2>{{$t('Formularios.Cuidados')}}</h2>
                        <p style="text-align:justify">{{producto.cuidadosEn}}</p>
                        </div>
                        <br>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <h2>{{$t('Formularios.Dimensiones')}}</h2>
                        <p>{{ $t('Busqueda.Largo')}} {{ producto.dimensiones.largo }}cm x {{ $t('Busqueda.Ancho')}} {{ producto.dimensiones.ancho }}cm x {{ $t('Busqueda.Alto')}} {{ producto.dimensiones.alto }}cm</p>
                      </v-col>
                    </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xs="12" md="4" :align="$vuetify.breakpoint.name === 'xs' ? 'center' : ''">
                <v-row style="padding-left:24px">
                    <v-col cols="12" class="pb-0">
                        <h1 class="font-weight-bold">{{ producto.titulo.toUpperCase() }}</h1>
                    </v-col>
                    <v-col cols="12" v-if="producto.exponer">
                      <h2>{{$t('Formularios.Exhibicion').toUpperCase() }}</h2>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <span class="font-weight-light">REF: {{producto.referencia}}</span>
                    </v-col>
                    <div>
                      <v-col cols="12" class="pt-0" >
                          <span style="color:#9e9e9e;">{{ producto.subcategoria.toUpperCase() }}</span>
                      </v-col>
                    </div>
                    <v-col cols="12">
                      <router-link :to="'/u/'+producto.artista.nombreDeUsuario" target= '_blank'>
                      <h3 class="font-weight-bold">{{ producto.artista.nombre }}</h3>
                      </router-link>
                      <span style="color:#9e9e9e;">{{$t('Menu.BiografiaObras')}}</span>
                    </v-col>
                    <v-col cols="12">
                      <p>{{$t('Busqueda.PaisDeOrigen')}}: {{producto.artista.pais}}</p>
                    </v-col>
                    <template v-if="!producto.exponer">
                      <v-col cols="12" v-if="producto.fisico && formato === 'fisico'">
                          <span class="font-weight-bold" style="font-size:24px;letter-spacing:.8px;">${{getValueProduct()}}</span>
                          <br>
                          <span v-if="producto.cantidadFisico > 0">{{producto.cantidadFisico}} {{$t('Busqueda.Disponibles')}}</span>
                          <p v-else class="vietnam headline"> {{$t('Busqueda.Agotado')}}</p>
                          <p v-if="producto.descuentoFisico > 0" class="vietnam headline">{{producto.descuentoFisico}}% {{$t('Carrito.Descuento')}}</p>
                      </v-col>
                      <v-col cols="12" v-if="producto.digital && formato === 'digital'">
                          <span class="font-weight-bold" style="font-size:24px;letter-spacing:.8px;">${{ getValueProduct()}}</span>
                          <br>
                          <span v-if="producto.ilimitado"> ({{$t('Formularios.Ilimitado')}})</span>
                          <span v-else-if="producto.cantidadDigital > 0"> ({{producto.cantidadDigital}} {{$t('Busqueda.Disponibles')}})</span>
                          <p v-else class="vietnam headline"> {{$t('Busqueda.Agotado')}}</p>
                          <br>
                          <span>{{$t('Formularios.Digital')}}</span>
                      </v-col>
                    </template>
                    <v-col cols="12" class="pb-0" v-if="producto.digital && producto.fisico">
                        <v-select solo :items="formatos" v-model="formato" item-text="titulo" item-value="id"></v-select>
                    </v-col>
                    <template v-if="!producto.exponer">
                      <v-col cols="12" class="py-0" v-if="producto.color && formato === 'fisico'" name="Colores">
                          <v-select solo :items="producto.colores" v-model="colorSeleccionado" item-value="tituloColor" :label="$t('Formularios.Color')">
                              <template slot="selection" slot-scope="data">
                                  <v-col cols="2">
                                      <v-avatar size="30" :color="data.item.color.hex" />
                                  </v-col>
                                  <v-col cols="10" class="ml-2">
                                      {{ $t('Categoria.'+data.item.tituloColor) }}
                                  </v-col>
                              </template>
                              <template slot="item" slot-scope="data">
                                  <v-list-item-avatar>
                                      <v-avatar :color="data.item.color.hex" size="30"></v-avatar>
                                  </v-list-item-avatar>
                                  <v-col cols="10" class="ml-2">
                                      {{ $t('Categoria.'+data.item.tituloColor) }}
                                  </v-col>
                                  <!-- <v-list-item-content>
                                      <v-list-item-title v-html="data.item.tituloColor" />
                                  </v-list-item-content> -->
                              </template>
                          </v-select>
                      </v-col>
                      <v-col cols="12" class="py-0" v-if="producto.talla && formato === 'fisico'" name="Tallas">
                          <v-select solo :items="producto.tallas" v-model="tallaSeleccionada" :label="$t('Formularios.Talla')"></v-select>
                      </v-col>
                      <v-col cols="12" v-if="producto.talla" style="margin-top:-30px;margin-bottom:20px;">
                          <v-btn text small @click="validarTabla">{{$t('Formularios.TablaTallas')}}</v-btn>
                      </v-col>
                      <v-col cols="12" class="mt-5" v-if="producto.cantidadFisico > 0 || producto.ilimitado || producto.cantidadDigital > 0">
                        <v-btn class="mt-3 mr-3" color="primary white--text" style="min-width:20%!important" x-large :disabled="disponibles === 0" @click="carrito()">
                          <span v-if="comprado === true" style="padding: 0 75px"><v-icon color="white">fas fa-check</v-icon></span>
                          <div v-else>
                            <div v-if="producto.fisico && formato === 'fisico'">
                              <span v-if="producto.cantidadFisico > 0">{{$t('Busqueda.Carrito')}}</span>
                            </div>
                            <div v-if="producto.digital && formato === 'digital'">
                              <span v-if="producto.ilimitado">{{$t('Busqueda.Carrito')}}</span>
                              <span v-else-if="producto.cantidadDigital > 0">{{$t('Busqueda.Carrito')}}</span>
                            </div>
                          </div>
                        </v-btn>
                      </v-col>
                    </template>
                    <v-col cols="12">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" class="mx-3" icon :color="producto.mg ? 'red' : 'secondary'" @click="favorito()"><v-icon size="32">fas fa-heart</v-icon></v-btn>
                        </template>
                        <span>{{$t('Inicio.Favorito')}}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" class="mx-3" icon color="primary" @click="compartir()"><v-icon size="32">fas fa-share</v-icon></v-btn>
                        </template>
                        <span>{{$t('Inicio.Compartir')}}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" v-if="producto.encargoDias">
                      <p>{{$t('Formularios.EncargoDias')}}: {{producto.encargoDias}}</p>
                    </v-col>
                    <v-row v-if="$vuetify.breakpoint.name === 'xs'">
                      <v-col cols="12" class="pb-0 pt-5">
                        <h3>{{$t('Formularios.Descripcion')}}</h3>
                        <p>{{producto.descripcion}}</p>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <h3>{{$t('Formularios.Materiales')}}</h3>
                        <p>{{producto.materiales}}</p>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <h3>{{$t('Formularios.Tecnica')}}</h3>
                        <p>{{producto.tecnica}}</p>
                      </v-col>
                      <v-col cols="12" class="py-0" v-if="producto.cuidados">
                        <h3>{{$t('Formularios.Cuidados')}}</h3>
                        <p>{{producto.cuidados}}</p>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <h3>{{$t('Formularios.Dimensiones')}}</h3>
                        <p>{{ $t('Busqueda.Largo')}} {{ producto.dimensiones.largo }}cm x {{ $t('Busqueda.Ancho')}} {{ producto.dimensiones.ancho }}cm x {{ $t('Busqueda.Alto')}} {{ producto.dimensiones.alto }}cm</p>
                      </v-col>
                    </v-row>
                    <v-col cols="12">
                      <p class="mb-0">{{$t('Menu.NecesitasAyuda')}}</p>
                      <v-btn large style="font-weight:bold" class="mt-2 mr-2 mb-5" color="grey lighten-1" target="_blank" :to="$t('Alias.Asesoria')">{{$t('Menu.Asesoria')}}</v-btn>
                      <p class="font-weight-bold my-5" style="text-decoration:underline;pointer:click;"><a href="https://wa.me/573213025754" target="_blank">{{$t('Menu.ContactoTrArtist')}}</a></p>
                      <v-btn v-if="!producto.exponer" large style="font-weight:bold" class="mt-5 mr-2" color="grey lighten-1" target="_blank" :to="$t('Alias.EnviosYDevoluciones')">{{$t('Menu.EnviosYDevoluciones')}}</v-btn>
                    </v-col>
                    <v-col cols="12">
                      <v-icon color="secondary">fas fa-check</v-icon><span class="ml-2 black--text">{{$t('Menu.CompraSegura')}}</span>
                      <br>
                      <v-icon color="secondary">fas fa-check</v-icon><span class="ml-2 black--text">{{$t('Menu.CertificadoAutenticidad')}}</span>
                      <br>
                      <v-icon color="secondary">fas fa-check</v-icon><span class="ml-2 black--text">{{$t('Menu.EntregasInternacionales')}}</span>
                      <br>
                      <v-icon color="secondary">fas fa-check</v-icon><span class="ml-2 black--text">{{$t('Menu.DíasDevoluciones')}}</span>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12" md="2" xs="0"></v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <h2>{{$t('Formularios.Descripcion')}}</h2>
                <br>
                <p>{{producto.descripcion}}</p>
              </v-col>
              <v-col cols="12">
                <h2>{{$t('Formularios.Materiales')}}</h2>
                <br>
                <p>{{producto.materiales}}</p>
              </v-col>
              <v-col cols="12">
                <h2>{{$t('Formularios.Tecnica')}}</h2>
                <br>
                <p>{{producto.tecnica}}</p>
              </v-col>
              <v-col cols="12">
                <h2>{{$t('Formularios.Cuidados')}}</h2>
                <br>
                <p>{{producto.cuidados}}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row> -->
        <v-dialog v-model="dialogTallas" style="margin:0;" width="60%">
            <v-row style="margin:0;">
                <v-col cols="12" align="center" style="margin:0;padding:0;">
                    <v-img contain height="100%" :src="producto.tablaDeTallas" />
                </v-col>
            </v-row>
        </v-dialog>
    </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import zoom from '../components/Zoom.vue'
import vueHeadful from 'vue-headful'
import Pwa from '../components/Pwa.vue'
export default {
  name: 'Producto',
  props: ['idProducto'],
  components: {
    zoom,
    vueHeadful,
    Pwa
  },
  data () {
    return {
      tipoPreview: 'imagen',
      activador: false,
      producto: null,
      colorSeleccionado: null,
      tallaSeleccionada: null,
      uidInventario: null,
      formato: null,
      comprado: false,
      formatos: [
        {
          titulo: this.$i18n.t('Busqueda.Fisico'),
          id: 'fisico'
        },
        {
          titulo: this.$i18n.t('Busqueda.Digital'),
          id: 'digital'
        }
      ],
      dialogTallas: false,
      imagenSeleccionada: null
    }
  },
  watch: {
    getIdioma: function (n, o) {
      if (n) {
        let subcat = this.$i18n.t(`Categoria.${this.producto.subcategoria}`)
        this.producto.subcategoria = subcat
      }
    }
  },
  mounted () {
    firebase.firestore().collection('productos').doc(this.idProducto).get().then(info => {
      this.producto = info.data()
      if (info.data().digital) {
        this.formato = 'digital'
      }
      if (info.data().fisico) {
        this.formato = 'fisico'
      }
      this.imagenSeleccionada = info.data().imagenPrincipal
      if (this.getUsuario.favoritos && this.getUsuario.favoritos.includes(info.data().uid)) {
        this.producto.mg = true
      }
      // console.log(this.producto)
      let subcat = this.$i18n.t(`Categoria.${this.producto.subcategoria}`)
      this.producto.subcategoria = subcat
    })
    setTimeout(() => this.activar(), 3000)
  },
  computed: {
    ...mapGetters(['getUsuario', 'getMoneda', 'getDolar', 'getMostrado', 'getPwa', 'getIdioma']),
    /* eslint-disable */
    disponibles: function () {
      var respuesta = 0
      if (this.formato === 'digital') {
        if (this.producto.ilimitado) {
          respuesta = 'Ilimitado'
        } else {
          respuesta = this.producto.cantidadDigital
        }
      } else {
        if (!this.producto.color && !this.producto.talla) {
          respuesta = this.producto.inventario[0].cantidad
          this.uidInventario = this.producto.inventario[0].uid
        }
        if (!this.producto.color && this.producto.talla) {
          for (let i = 0; i < this.producto.inventario.length; i++) {
            if (this.producto.inventario[i].talla === this.tallaSeleccionada) {
              respuesta = this.producto.inventario[i].cantidad
              this.uidInventario = this.producto.inventario[i].uid
              break
            }
          }
        }
        if (this.producto.color && !this.producto.talla) {
          for (let i = 0; i < this.producto.inventario.length; i++) {
            if (this.producto.inventario[i].color.tituloColor === this.colorSeleccionado) {
              respuesta = this.producto.inventario[i].cantidad
              this.uidInventario = this.producto.inventario[i].uid
              break
            }
          }
        }
        if (this.producto.color && this.producto.talla) {
          for (let i = 0; i < this.producto.inventario.length; i++) {
            if (this.producto.inventario[i].color.tituloColor === this.colorSeleccionado) {
              if (this.producto.inventario[i].talla === this.tallaSeleccionada) {
                respuesta = this.producto.inventario[i].cantidad
                this.uidInventario = this.producto.inventario[i].uid
                break
              }
            }
          }
        }
      }
      return respuesta
    }
    /* eslint-enable */
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta', 'setActivador', 'setMostrado']),
    ...mapActions(['anadirCarrito']),
    getValueProduct () {
      if (this.getMoneda === 'COP') {
        if (this.producto.precioCOL) {
          return Math.round(Number(this.producto.precioPago)).toLocaleString()
        } else {
          return Math.round(Number(this.producto.precioPago)).toLocaleString() * this.getDolar
        }
      } else {
        if (this.producto.precioCOL) {
          return Math.round(Number(this.producto.precioPago)).toLocaleString() / this.getDolar
        } else {
          return Math.round(Number(this.producto.precioPago)).toLocaleString()
        }
      }
    },
    activar () {
      if (!this.getMostrado) {
        if (this.getPwa === null) {
          this.setMostrado(true)
        } else {
          this.setActivador(true)
          this.setMostrado(true)
        }
      }
    },
    compartir () {
      var dummy = document.createElement('input')
      var text = window.location.href
      document.body.appendChild(dummy)
      dummy.value = text
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)
      this.setAlerta()
      this.setTextoAlerta('Alerta.Copiado')
    },
    selImagen (url, tipo) {
      if (tipo === 'imagen') {
        this.imagenSeleccionada = url
        this.tipoPreview = 'imagen'
      } else {
        this.tipoPreview = 'video'
      }
    },
    carrito () {
      this.comprado = true
      setTimeout(() => {
        this.comprado = false
        return this.comprado
      }, 1500)
      var info = {
        formato: this.formato
      }
      if (info.formato === 'fisico') {
        info.producto = {
          uid: this.producto.uid,
          titulo: this.producto.titulo,
          precio: Number(this.producto.precioPago),
          costeEnvio: Number(this.producto.costeEnvio),
          envioIncluido: Boolean(this.producto.envioIncluido),
          totalProducto: Number(this.producto.precioPago),
          cantidad: 1,
          dimensiones: this.producto.dimensiones,
          normal: true,
          enrollado: false,
          dimensionesEnrollado: this.producto.dimensionesEnrollado,
          maximaCantidad: Number(this.disponibles),
          imagenPrincipal: this.producto.imagenPrincipal,
          categoria: this.producto.categoria,
          referencia: this.producto.referencia,
          totalArtista: Number(this.producto.precioFisico),
          artista: {
            uid: this.producto.artista.uid,
            nombre: this.producto.artista.nombre,
            pais: this.producto.artista.pais,
            email: this.producto.artista.email,
            codigo: this.producto.artista.codigo,
            codigoPostal: this.producto.artista.codigoPostal
          },
          subcategoria: this.producto.subcategoria,
          tipo: 'fisico',
          talla: this.tallaSeleccionada,
          color: this.colorSeleccionado,
          uidInventario: this.uidInventario
        }
        if (this.producto.color) {
          info.producto.color = this.colorSeleccionado
        }
        if (this.producto.talla) {
          info.producto.talla = this.tallaSeleccionada
        }
      } else {
        info.producto = {
          uid: this.producto.uid,
          titulo: this.producto.titulo,
          precio: Number(this.producto.precioPagoDig),
          costeEnvio: Number(this.producto.costeEnvio),
          envioIncluido: Boolean(this.producto.envioIncluido),
          totalProducto: Number(this.producto.precioPagoDig),
          cantidad: 1,
          maximaCantidad: Number(this.disponibles),
          dimensiones: this.producto.dimensiones,
          normal: true,
          enrollado: false,
          dimensionesEnrollado: this.producto.dimensionesEnrollado,
          imagenPrincipal: this.producto.imagenPrincipal,
          categoria: this.producto.categoria,
          totalArtista: Number(this.producto.precioDigital),
          artista: {
            uid: this.producto.artista.uid,
            nombre: this.producto.artista.nombre,
            pais: this.producto.artista.pais,
            email: this.producto.artista.email,
            codigo: this.producto.artista.codigo,
            codigoPostal: this.producto.artista.codigoPostal
          },
          subcategoria: this.producto.subcategoria,
          tipo: 'digital',
          archivoDigital: this.producto.archivoDigital
        }
      }
      this.anadirCarrito(info)
    },
    favorito () {
      if (this.producto.mg) {
        this.producto.mg = false
        firebase.firestore().collection('usuarios').doc(this.getUsuario.uid).update({
          favoritos: firebase.firestore.FieldValue.arrayRemove(this.producto.uid)
        })
        firebase.firestore().collection('productos').doc(this.producto.uid).update({
          meGusta: firebase.firestore.FieldValue.increment(-1)
        })
        this.setAlerta()
        this.setTextoAlerta('Alerta.NoMeGusta')
      } else {
        if (this.getUsuario.rol !== 'invitado') {
          this.producto.mg = true
          firebase.firestore().collection('usuarios').doc(this.getUsuario.uid).update({
            favoritos: firebase.firestore.FieldValue.arrayUnion(this.producto.uid)
          })
          firebase.firestore().collection('productos').doc(this.producto.uid).update({
            meGusta: firebase.firestore.FieldValue.increment(1)
          })
          this.setAlerta()
          this.setTextoAlerta('Alerta.MeGusta')
        } else {
          this.setAlerta()
          this.setTextoAlerta('Alerta.SinMeGusta')
        }
      }
    },
    validarTabla () {
      let elemento = this.producto.tablaDeTallas

      if (elemento.includes('.jpg') || elemento.includes('.jpeg') || elemento.includes('.png')) {
        // console.log('Imagen permitida: ', elemento)
        this.dialogTallas = true
      } else {
        window.open(elemento, '_blank')
      }
    }
  }
}
</script>

<style>
.v-expansion-panels--flat > .v-expansion-panel::after {
  border-top: none;
}
.v-expansion-panels--flat > .v-expansion-panel::before {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}
.video-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  padding-top: 0!important;
}
.video-wrapper iframe,
.video-wrapper object,
.video-wrapper embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.v-expansion-panel-header {
  padding-left: 0!important;
}
</style>
